import apiHttpClient from "libs/api-http-client";
import { Adjustment } from "types/adjustment";

export const getAdjustmentAPI = (adjustmentId: number): Promise<Adjustment> =>
  apiHttpClient.get(`/fund-adjustments/${adjustmentId}`);
